import * as types from "../actions/index";
export default function(state = [], action) {
  switch (action.type) {
    case types.FETCH_UNREAD_NOTIFICATION_COUNT:
      return action.payload;

    default:
      return state;
  }
}
